import axios from "axios";
import { useState, useEffect } from "react";
import { baseUrl } from "../constants/url";
import getHeaders from "../utils/getHeaders";
import "./style.css";
import { Link } from "react-router-dom";

const MemberPayment = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const token = localStorage.getItem("MemberAuth");
    const isAdminLogin = localStorage.getItem("isAdminLogin");
    const memberCode = localStorage.getItem("MemberCode");
    const memberId = localStorage.getItem("MemberId");
    
    console.log("Initial state check:");
    console.log("Token:", token);
    console.log("isAdminLogin:", isAdminLogin);
    console.log("MemberCode:", memberCode);
    console.log("MemberId:", memberId);
    
    const isValid = !!token && token !== "null" && token !== "undefined" && token !== "" && !isAdminLogin;
    console.log("Initial isLoggedIn:", isValid);
    
    return isValid;
  });
  const [otpSent, setOtpSent] = useState(false);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [outstanding, setOutstanding] = useState(0);
  const [payAmount, setPayAmount] = useState<any>("");

  const sendOTP = async (e: any) => {
    e.preventDefault();
    setError("");
    if (mobile) {
      try {
        setLoading(true);
        console.log(mobile);
        let response: any = await fetch(`${baseUrl}/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mobileNo: mobile,
            isAdmin: false
          }),
        });

          const data = await response.json();
        if (
          (response.status >= 200 && response.status < 300) ||
          response.status === 304
        ) {
          if (data.message.includes("No member found")) {
            setError("No member found for this mobile number!");
            return;
        }
          setOtpSent(true);
        } else {
          response = await response.json();
          setError(response.message);
        }
      } catch (error: any) {
        console.log(error);
        alert(error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const login = async (e: any) => {
    try {
      e.preventDefault();
      setLoading(true);
      setError("");
      const res = await fetch(`${baseUrl}/verifyuser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobileNo: mobile,
          OTPText: parseInt(otp),
          isAdmin: false
        }),
      });
      const data = await res.json();
      if (res.status === 200) {
        if (data.data.token) {
          localStorage.setItem("localuser", JSON.stringify(data.data));
          localStorage.setItem("MemberCode", data.data.memberCode);
          localStorage.setItem("MemberId", data.data.memberId);
          localStorage.setItem("MemberMobile", mobile);
          localStorage.setItem("MemberAuth", data.data.token);
          localStorage.setItem(
            "lastMemberAuthTimeMillis",
            String(new Date().getTime())
          );
          setIsLoggedIn(true);
        }
      } else {
        setError(data.message);
      }
    } catch (error: any) {
      console.log(error, " <== errorhere");
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchOutstandingAmount = async () => {
    // Check if we have a valid token before making the API call
    const token = localStorage.getItem("MemberAuth");
    const memberCode = localStorage.getItem("MemberCode");
    const memberId = localStorage.getItem("MemberId");
    
    console.log("fetchOutstandingAmount - Token:", token);
    console.log("fetchOutstandingAmount - MemberCode:", memberCode);
    console.log("fetchOutstandingAmount - MemberId:", memberId);
    
    if (!token || token === "null" || token === "undefined" || token === "") {
      console.log("No valid token found, logging out");
      setIsLoggedIn(false);
      return;
    }

    try {
      const response = await fetch(`${baseUrl}/GetCurrentOutstanding`, {
        method: "GET",
        headers: {
          ...getHeaders(),
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log(JSON.stringify(data));
        setOutstanding(-data.value);
        if (data.value < 0) {
          setPayAmount(-data.value || "");
        }
      } else if (response.status === 401 || response.status === 403) {
        // Only logout on authentication errors
        console.log("Authentication error, logging out");
        setIsLoggedIn(false);
        localStorage.clear();
      } else {
        // For other HTTP errors, just log them
        console.log("API error:", response.status, response.statusText);
      }
    } catch (error) {
      console.log(error, " <=== Network or other error");
      // Don't logout on network errors or other exceptions
    }
  };

  useEffect(() => {
    console.log("useEffect triggered, isLoggedIn:", isLoggedIn);
    if (isLoggedIn) {
      console.log("User is logged in, fetching outstanding amount");
      fetchOutstandingAmount();
    } else {
      console.log("User is not logged in");
    }
  }, [isLoggedIn]);


  const handleSubmit = async () => {
    const { authorization, membercode, memberid } = getHeaders();
    let res = await axios.post(
      `${baseUrl}/outstandingPayment`,
      { amount: payAmount },
      { headers: { ...getHeaders() } }
    );
    const data = res.data.data;
    const url = `${window.location.origin}/payment?userToken=${
      authorization.split(" ")[1]
    }&order_id=${
      data.order_id
    }&memberCode=${membercode}&memberId=${memberid}&amount=${payAmount}`;
    window.location.assign(url);
  };

  return (
    <>
      {!isLoggedIn && (
        <>
          <div className="login">
            <div className="login-page">
              <h1>Login</h1>
              <div className="card">
                <form className="form-part">
                  <div className="form-field phone-no-field">
                    <input
                      disabled={loading}
                      type="tel"
                      placeholder="Enter Phone No"
                      onChange={(e) => {
                        setMobile(e.target.value);
                        setError("");
                      }}
                    />

                    <button
                      disabled={!mobile || mobile.length !== 10}
                      onClick={sendOTP}
                      className="send-otp-link"
                    >
                      Send OTP
                    </button>
                  </div>
                  <div className="form-field">
                    <input
                      disabled={!otpSent || loading}
                      placeholder="OTP"
                      type="text"
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  <div className="button-part">
                    <button
                      onClick={login}
                      className="submit-btn"
                      disabled={!otpSent || loading}
                      type="button"
                    >
                      {loading ? "Loading..." : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}

      {isLoggedIn && (
        <>
          <div className="header-link-part">
            <Link className="header__link" to={"/club-magazine"}>
              Club Magazine
            </Link>
            <Link className="header__link" to={"/bill-list"}>
              Bills
            </Link>
            <Link className="header__link" to={"/upcomingEvents"}>
              Upcoming Events
            </Link>
            <Link className="header__link" to={"/contact-us"}>
              Contact Us
            </Link>
            <Link className="header__link" to={"/receipt-list"}>
              Receipt List
            </Link>
            <a
              className="header__link"
              style={{ backgroundColor: "red", color: "white"}}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                localStorage.clear();
                window.location.reload();
              }}
            >
              Logout
            </a>
          </div>
          <div className="page-information">
            <p>
              Your current balance is :{" "}
              <strong
                style={outstanding < 0 ? { color: "green" } : { color: "red" }}
              >
                {-outstanding}{" "}
              </strong>{" "}
              <span style={{ fontSize: 14, fontWeight: "bold" }}>
                {" "}
                {outstanding < 0 ? "CR." : "DR."}{" "}
              </span>{" "}
            </p>
            <p>
              Your current outstanding is :{" "}
              <strong>{outstanding > 0 ? outstanding : 0} </strong>
            </p>
            <input
              type="number"
              min="0"
              value={payAmount}
              onChange={(e: any) => {
                setPayAmount(parseFloat(e.target.value));
                console.log(parseFloat(e.target.value));
              }}
              name="amount"
              id="amount_to_be_paid"
            />
            <button
              onClick={(e: any) => {
                handleSubmit();
              }}
            >
              Pay Now
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default MemberPayment;
